import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import React from 'react';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { connect } from "react-redux";
import { getFormations } from "../../../../../../actions/entreprise/actions_entreprise_entretien";
import AuthService from "../../../../../../services/AuthService";
import CustomDatePicker from '../../../../../shared/utils/CustomDatePicker';
import moment from "../../../../../shared/utils/moment_fr";

class ExampleComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            id_salarie: "",
            nom_formation: "",
            id_type: "",
            duree: "",
            rating: null,
            rating_comment: null,
            id_initiative: "",
            date_rea: new Date().toISOString().substring(0, 10),
            initiateur: "",
            type: "",
            validated: true
        };
        this.Auth = new AuthService();
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.setState({ id_salarie: this.props.entretienHeader.id_salarie || this.props.id_salarie })
    }

    handleChange(event, value) {
        let obj = {};
        obj[event.target.name] = value;
        this.setState(obj);
    }

    handleSubmit() {
        const eh = this.props.entretienHeader;
        this.Auth.fetch('/salarie/formation',
            {
                method: 'post',
                data: this.state
            }).then(x => {
                !this.props.onSuccess && this.props.dispatch(getFormations(eh.id, eh.id_salarie));
                alert('Formation ajoutée avec succès.');
                this.props.onSuccess && this.props.onSuccess(this.state);
            });
    }

    render() {
        return (
            <ValidatorForm
                ref="form"
                onSubmit={this.handleSubmit}
            >
                <TextValidator
                    value={this.state.nom_formation}
                    onChange={this.handleChange}
                    fullWidth={true}
                    name='nom_formation'
                    type="text"
                    validators={['required', 'trim']}
                    errorMessages={['Ce champs est obligatoire', 'Ce champs est obligatoire']}
                    floatingLabelText="Nom de la formation"
                />
                <TextValidator
                    value={this.state.nom_organisme_de_formation}
                    onChange={this.handleChange}
                    fullWidth={true}
                    name='nom_organisme_de_formation'
                    type="text"
                    validators={['required', 'trim']}
                    errorMessages={['Ce champs est obligatoire', 'Ce champs est obligatoire']}
                    floatingLabelText="Nom de l'organisme de la formation"
                />
                <SelectField
                    value={this.state.id_type}
                    fullWidth={true}
                    floatingLabelText="Type de validation"
                    onChange={(x, y, z) => this.handleChange({ target: { name: 'id_type' } }, z)}
                    maxHeight={400}
                >
                    {this.props.types_validation_formation.map(x => <MenuItem key={x.id} value={x.id}
                        primaryText={x.type} />)}
                </SelectField>
                <TextValidator
                    value={this.state.duree}
                    onChange={this.handleChange}
                    fullWidth={true}
                    name='duree'
                    type="number"
                    validators={['required', 'trim', 'isNumber']}
                    errorMessages={['Ce champs est obligatoire', 'Ce champs est obligatoire', 'Numéro seulement']}
                    floatingLabelText="Durée de la formation (Heures)"
                />

                <SelectField
                    value={this.state.id_initiative}
                    fullWidth={true}
                    floatingLabelText="Initiative"
                    onChange={(x, y, z) => this.handleChange({ target: { name: 'id_initiative' } }, z)}
                    maxHeight={400}
                >
                    {this.props.initiatives.map(x => <MenuItem key={x.id} value={x.id} primaryText={x.initiateur} />)}
                </SelectField>
                <CustomDatePicker
                    floatingLabelText="Date de réalisation"
                    stringValue={this.state.date_rea}
                    onChange={(x, y) => this.handleChange({ target: { name: 'date_rea' } }, moment(y).format("YYYY-MM-DD"))}
                />
                <RaisedButton
                    style={{ marginTop: 25 }}
                    primary={true}
                    label={'Ajouter'}
                    type={'submit'} />
            </ValidatorForm>
        );
    }
}

function mapStateToProps(store) {
    return {
        types_validation_formation: store.params.types_validation_formation,
        initiatives: store.params.initiatives,
        entretienHeader: store.entretien.header
    }
}

export default connect(mapStateToProps)(ExampleComponent);


// WEBPACK FOOTER //
// ./src/components/entreprise/bodies/entretiens/passer_entretien/comps/FormationForm.js